import _ from "lodash";
import AbstractCollection from "./abstractCollection";

class TeamLogoCollection extends AbstractCollection {
  /**
   *
   * @param {TeamLogo[]} teamLogos
   */
  constructor(teamLogos) {
    super(teamLogos);
    this._activeLogo = undefined;
  }

  /**
   *
   * @returns {?TeamLogo}
   */
  getActiveLogo() {
    if (_.isUndefined(this._activeLogo)) {
      const activeLogos = this.items.filter((logo) => logo.isActive);
      if (activeLogos.length === 1) {
        this._activeLogo = activeLogos[0];
      } else if (activeLogos.length > 1) {
        throw new Error(
          `TeamLogoCollection.getActiveLogo() - ERROR - found ${activeLogos.length} active logos`
        );
      } else {
        this._activeLogo = null;
      }
    }
    return this._activeLogo;
  }

  /**
   *
   * @param {string|number} week
   * @returns {TeamLogo}
   */
  getLogoByWeek(week) {
    let matches = [];
    this.items.forEach((logo) => {
      if (
        logo.obj.startWeek <= week &&
        (!logo.obj.endWeek || logo.obj.endWeek >= week)
      ) {
        matches.push(logo);
      }
    });

    if (matches.length === 0)
      throw new Error(
        `TeamLogoCollection.getLogoByWeek() - ERROR - Could not find logo by week: ${week}`
      );

    if (matches.length === 1) return matches[0];

    // if multiple matches found, sort them by start week and then return the latest one
    matches.sort((a, b) => {
      if (a.obj.startWeek === b.obj.startWeek) return 0;
      return a.obj.startWeek < b.obj.startWeek ? -1 : 1;
    });
    return matches.pop();
  }
}

export default TeamLogoCollection;
